import useSWR from 'swr';
import { useCustomerApi } from '../useCustomerApi/useCustomerApi';

export const useCustomerInformation = () => {
  const customerApi = useCustomerApi();

  const { data: customerInformation, isLoading } = useSWR(
    customerApi ? 'customerInformation' : null,
    () => customerApi!.getInformation(),
    { revalidateOnFocus: false },
  );

  return {
    customerInformation,
    isLoading,
  };
};
